export default "https://d1e6s5z4lzmgxx.cloudfront.net/3cbd492b-c681-4587-ab2f-cab322978701/images/chevron-right-white.png?56e86e127cf2dd6457b56e621ab05124";